var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconF(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 55C42.6878 55 55 42.6878 55 27.5C55 12.3122 42.6878 0 27.5 0C12.3122 0 0 12.3122 0 27.5C0 42.6878 12.3122 55 27.5 55Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4008 26.8981C35.8514 22.4301 32.0068 19 27.4348 19C22.7429 19 18.8678 22.5539 18.441 27.1624C16.3955 27.8571 15 29.7657 15 31.9375C15 34.7286 17.2818 37 20.087 37H35.913C38.7182 37 41 34.7286 41 31.9375C41 29.3101 38.9782 27.1433 36.4008 26.8981ZM32.9275 30.3906C32.3481 32.626 30.3224 34.1875 28.0005 34.1875C26.6745 34.1875 25.4168 33.6632 24.4803 32.7711L22.9141 34.1875L23.0949 30.43L26.87 30.61L25.3208 32.0112C26.0431 32.6727 26.9955 33.0625 28.0005 33.0625C29.8063 33.0625 31.3821 31.848 31.8321 30.1093C31.9101 29.8084 32.2221 29.629 32.5205 29.7049C32.8229 29.7825 33.0049 30.0891 32.9275 30.3906ZM29.1299 27.64L32.9056 27.82L33.0859 24.0625L31.5203 25.4783C30.5769 24.5766 29.3176 24.0625 27.9995 24.0625C25.677 24.0625 23.6507 25.624 23.0725 27.8599C22.9951 28.1603 23.1771 28.4674 23.4795 28.5445C23.5264 28.5569 23.5739 28.5625 23.6208 28.5625C23.8723 28.5625 24.1018 28.3943 24.1679 28.1406C24.6173 26.4019 26.1931 25.1875 27.9995 25.1875C28.9994 25.1875 29.9569 25.5655 30.6843 26.2343L29.1299 27.64Z",
    fill: "#0F53FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconF);
export default __webpack_public_path__ + "static/media/IconF.46c3bd36037138081510f9c2d6094e2e.svg";
export { ForwardRef as ReactComponent };